var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { hasMany, belongsTo, attr } from '@ember-data/model';
import { DateTime } from 'luxon';
import { TrackedAsyncData } from 'ember-async-data';
import { cached } from '@glimmer/tracking';
import { mapBy, sortBy, uniqueValues } from 'ilios-common/utils/array-helpers';
let Offering = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('date'), _dec5 = attr('date'), _dec6 = attr('date'), _dec7 = belongsTo('session', {
  async: true,
  inverse: 'offerings'
}), _dec8 = hasMany('learner-group', {
  async: true,
  inverse: 'offerings'
}), _dec9 = hasMany('instructor-group', {
  async: true,
  inverse: 'offerings'
}), _dec10 = hasMany('user', {
  async: true,
  inverse: 'offerings'
}), _dec11 = hasMany('user', {
  async: true,
  inverse: 'instructedOfferings'
}), _class = class Offering extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "room", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "url", _descriptor3, this);
    _initializerDefineProperty(this, "startDate", _descriptor4, this);
    _initializerDefineProperty(this, "endDate", _descriptor5, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor6, this);
    _initializerDefineProperty(this, "session", _descriptor7, this);
    _initializerDefineProperty(this, "learnerGroups", _descriptor8, this);
    _initializerDefineProperty(this, "instructorGroups", _descriptor9, this);
    _initializerDefineProperty(this, "learners", _descriptor10, this);
    _initializerDefineProperty(this, "instructors", _descriptor11, this);
  }
  get _learnerGroupsData() {
    return new TrackedAsyncData(this.learnerGroups);
  }
  get _instructorGroupsData() {
    return new TrackedAsyncData(this.instructorGroups);
  }
  get _learnersData() {
    return new TrackedAsyncData(this.learners);
  }
  get _instructorsData() {
    return new TrackedAsyncData(this.instructors);
  }
  get startDayOfYear() {
    return DateTime.fromJSDate(this.startDate).toFormat('ooo');
  }
  get startYear() {
    return DateTime.fromJSDate(this.startDate).toFormat('yyyy');
  }
  get startTime() {
    return DateTime.fromJSDate(this.startDate).toFormat('HHmm');
  }
  get endDayOfYear() {
    return DateTime.fromJSDate(this.endDate).toFormat('ooo');
  }
  get endYear() {
    return DateTime.fromJSDate(this.endDate).toFormat('yyyy');
  }
  get endTime() {
    return DateTime.fromJSDate(this.endDate).toFormat('HHmm');
  }
  get startYearAndDayOfYear() {
    return DateTime.fromJSDate(this.startDate).toFormat('oooyyyy');
  }
  get endYearAndDayOfYear() {
    return DateTime.fromJSDate(this.endDate).toFormat('oooyyyy');
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get isSingleDay() {
    return this.startYearAndDayOfYear === this.endYearAndDayOfYear;
  }
  get dateKey() {
    return this.startYear + this.startDayOfYear;
  }
  get timeKey() {
    const properties = [this.startYear, this.startDayOfYear, this.startTime, this.endYear, this.endDayOfYear, this.endTime];
    let key = '';
    for (let i = 0; i < properties.length; i++) {
      key += properties[i];
    }
    return key;
  }
  get _instructorsInGroups() {
    if (!this._instructorGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._instructorGroupsData.value.map(g => g.users)));
  }
  get allInstructors() {
    if (!this._instructorsData.isResolved || !this._instructorsInGroups || !this._instructorsInGroups.isResolved) {
      return [];
    }
    return sortBy(uniqueValues([...this._instructorsData.value, ...this._instructorsInGroups.value.flat()]), 'fullName');
  }
  get _learnersInGroups() {
    if (!this._learnerGroupsData.isResolved) {
      return null;
    }
    return new TrackedAsyncData(Promise.all(this._learnerGroupsData.value.map(g => g.users)));
  }
  get allLearners() {
    if (!this._learnersData.isResolved || !this._learnersInGroups || !this._learnersInGroups.isResolved) {
      return [];
    }
    return sortBy(uniqueValues([...this._learnersData.value, ...this._learnersInGroups.value.flat()]), 'fullName');
  }
  get durationHours() {
    if (!this.startDate || !this.endDate) {
      return 0;
    }
    return DateTime.fromJSDate(this.endDate).diff(DateTime.fromJSDate(this.startDate), ['hours', 'minutes']).hours;
  }
  get durationMinutes() {
    if (!this.startDate || !this.endDate) {
      return 0;
    }
    const mEnd = DateTime.fromJSDate(this.endDate);
    const endHour = mEnd.hour;
    const endMinute = mEnd.minute;
    const mStart = DateTime.fromJSDate(this.startDate).set({
      hour: endHour
    });
    const startMinute = mStart.minute;
    let diff = 0;
    if (endMinute > startMinute) {
      diff = endMinute - startMinute;
    } else if (endMinute < startMinute) {
      diff = 60 - startMinute + endMinute;
    }
    return diff;
  }

  /**
   * Retrieves a list of all instructors that are either directly attached to this offering,
   * or that are attached via instructor groups.
   * @returns {Promise<Array>}
   */
  async getAllInstructors() {
    const instructors = await this.instructors;
    const instructorGroups = await this.instructorGroups;
    const instructorsInInstructorGroups = await Promise.all(mapBy(instructorGroups, 'users'));
    return uniqueValues([...instructors, ...instructorsInInstructorGroups.map(instructorGroup => instructorGroup).flat()]);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "room", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "url", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "startDate", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "endDate", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "session", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "learnerGroups", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_learnerGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnerGroupsData"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "instructorGroups", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_instructorGroupsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorGroupsData"), _class.prototype), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "learners", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_learnersData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnersData"), _class.prototype), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "instructors", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "_instructorsData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorsData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_instructorsInGroups", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_instructorsInGroups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_learnersInGroups", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "_learnersInGroups"), _class.prototype), _class);
export { Offering as default };